import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useMsal, useAccount, useIsAuthenticated, useMsalAuthentication } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';

import { authRequest } from '../config/auth.config';

import { userActions } from 'common/redux/user';

const useLogin = () => {
    const dispatch = useDispatch();
    const isAuthenticated = useIsAuthenticated();
    const { login, error, acquireToken } = useMsalAuthentication(
        InteractionType.Silent,
        authRequest
    );
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0]);
    const [isAuthReady, setIsAuthReady] = useState<boolean>(false);

    useEffect(() => {
        if (error) {
            login(InteractionType.Redirect, authRequest);
        }
    }, [error, login]);

    useEffect(() => {
        if (isAuthenticated) {
            instance.setActiveAccount(account);
            acquireToken(InteractionType.Silent, authRequest).then((response) => {
                dispatch(userActions.getUserProfile());
                dispatch(userActions.getUserInfo());
                setIsAuthReady(true);
            });
        }
    }, [account, acquireToken, dispatch, instance, isAuthenticated]);

    return isAuthReady;
};

export default useLogin;
